import { render, staticRenderFns } from "./newDigitalFormsFieldsModal.vue?vue&type=template&id=518f1f24"
import script from "./newDigitalFormsFieldsModal.vue?vue&type=script&lang=js"
export * from "./newDigitalFormsFieldsModal.vue?vue&type=script&lang=js"
import style0 from "./newDigitalFormsFieldsModal.vue?vue&type=style&index=0&id=518f1f24&prod&lang=css"
import style1 from "./newDigitalFormsFieldsModal.vue?vue&type=style&index=1&id=518f1f24&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports